/* eslint-disable brace-style */
angular.module('tgaAdmin')
  .service('quillTooltipService',
    ['$document', '$compile',
      function ($document, $compile) {
        this.toolbarTooltips = {
          font: 'Select a font',
          size: 'Select a font size',
          header: 'Select the text style',
          bold: 'Bold',
          italic: 'Italic',
          underline: 'Underline',
          strike: 'Strikethrough',
          color: 'Select a text color',
          background: 'Select a background color',
          script: {
            sub: 'Subscript',
            super: 'Superscript',
          },
          list: {
            ordered: 'Numbered list',
            bullet: 'Bulleted list',
          },
          indent: {
            '-1': 'Decrease indent',
            '+1': 'Increase indent',
          },
          direction: {
            rtl: 'Text direction (right to left | left to right)',
            ltr: 'Text direction (left ro right | right to left)',
          },
          align: 'Text alignment',
          link: 'Insert a link',
          image: 'Insert an image',
          formula: 'Insert a formula',
          clean: 'Clear formatting',
          'add-table': 'Add a new table',
          'table-row': 'Add a row to the selected table',
          'table-column': 'Add a column to the selected table',
          'remove-table': 'Remove selected table',
          help: 'Show help',
        };
        this.showTooltips = (editor) => {
          const toolbarElement = editor.container.previousElementSibling;
          const scope = angular.element(toolbarElement).scope();
          const showTooltip = (which, el) => {
            let tool;
            if (which === 'button') {
              tool = el.className.replace('ql-', '');
            } else if (which === 'span') {
              tool = el.className.replace('ql-', '');
              tool = tool.substr(0, tool.indexOf(' '));
            }
            if (tool) {
              // if element has value attribute.. handling is different
              // buttons without value
              if (el.value === '') {
                if (this.toolbarTooltips[tool]) {
                  el.setAttribute('uib-tooltip', this.toolbarTooltips[tool]);
                }
              }
              // buttons with value
              else if (angular.isDefined(el.value)) {
                if (this.toolbarTooltips[tool][el.value]) el.setAttribute('uib-tooltip', this.toolbarTooltips[tool][el.value]);
              }
              // default
              else el.setAttribute('uib-tooltip', this.toolbarTooltips[tool]);
            }
          };

          if (toolbarElement) {
            const matchesButtons = toolbarElement.querySelectorAll('button');
            matchesButtons.forEach((el) => {
              showTooltip('button', el);
            });

            // for submenus inside
            const matchesSpans = toolbarElement.querySelectorAll('.ql-toolbar > span > span');
            matchesSpans.forEach((el) => {
              showTooltip('span', el);
            });
            $compile(toolbarElement)(scope);
          }
        };
      },
    ]);
